/* eslint-disable quotes */
import React from 'react';
import TextStyle from '@rezdy/components/TextStyle';
import Button from '@rezdy/components/Button';
import { WithTranslation, withTranslation } from 'react-i18next';
import { H4 } from '@rezdy/components/Heading';
import { SIGN_IN } from '../../constants/routes';
import routing from '../../services/routing';

export class EmailVerified extends React.PureComponent<WithTranslation> {
    handleClick = () => {
        routing.push(SIGN_IN);
    };

    render(): React.ReactNode {
        const { i18n } = this.props;
        return (
            <React.Fragment>
                <TextStyle align="left">
                    <H4>{i18n.t('verifyNewEmail.heading')}</H4>
                </TextStyle>
                <Button onClick={this.handleClick} style={{ width: '200px' }}>
                    {i18n.t('primaryAction', { context: 'loginDashboard' })}
                </Button>
            </React.Fragment>
        );
    }
}

export default withTranslation()(EmailVerified);
